import { getValue, setValue } from './localStorage';
import history from '../routes/history';
import I18n from '../config/locales';
import CountryBasedLink from '../config/constants';
import store from '../store';
import queryString from 'query-string';

export const getToken = () => {
  var token = getValue('_enlighten_manager_token');
  if (!token) {
    token = getValue('enlighten_manager_token_' + window.build_environment);
  }
  return token;
}

export const setToken = value => setValue('_enlighten_manager_token', value);

export const getSolargrafToken = () => getValue('_solargraf_token');

export const setSolargrafToken = value => setValue('_solargraf_token', value);

export const forwardTo = location => history.push(location);

export const getCountryBasedLink = key => {
  const country = store.getState().defaultReducer.country;
  const link = CountryBasedLink[country] || CountryBasedLink['US'];
  return link[key];
};

export const enlightenLinks = () => {
  const fleetDashBoardLink = store.getState().defaultReducer.fleetDashBoardLink;
  return {
    dashboard: { name: I18n.t('header.dashboard'), url: 'dashboard' },
    leads: { name: I18n.t('header.leads'), url: 'leads' },
    systems: fleetDashBoardLink
      ? {
          name: I18n.t('header.systems'),
          // url: `${fleetDashBoardLink}&locale=${I18n.locale || I18n.defaultLocale}`,
          url: 'fleet-dashboard-systems',
          isExternal: false
        }
      : { name: I18n.t('header.systems'), url: 'systems' },
    account: { name: I18n.t('header.account'), url: 'account' },
    services: { name: I18n.t('header.services'), url: 'account' },
    dataPrivacy: { name: I18n.t('header.dataPrivacy'), url: 'account' },
    support: { name: I18n.t('header.support'), url: 'account' },
    admin: { name: I18n.t('header.admin'), url: 'admin' },
    adminNew: { name: I18n.t('header.adminNew'), url: 'admin-new' }
  }
};

export const enlightenDistributorLinks = () => {
  return {
    "distributor-dashboard": { name: I18n.t('header.dashboard'), url: 'distributor-dashboard' },
    services: { name: I18n.t('header.services'), url: 'account' },
  }
};

export const enlightenHomeownerLinks = () => ({
  systems: { name: I18n.t('header.systems'), url: 'systems' },
  account: { name: I18n.t('header.account'), url: 'account' },
  support: { name: I18n.t('header.support'), url: getCountryBasedLink('support'), isExternal: true }
});

export const getSegregatedAddress = addressObject => {
  let addresses = addressObject.address_components;
  const streetNumber = addresses.find(
    address => address.types.includes('street_number') || address.types.includes('premise')
  );
  const locality = addresses.find(address => address.types.includes('locality') || address.types.includes('political'));
  const route = addresses.find(
    address => address.types.includes('route') || address.types.includes('sublocality_level_1')
  );
  const addressLocality = locality ? locality.long_name : '';
  const address1 = streetNumber && route ? [streetNumber.long_name, route.long_name].join(', ') : '';
  const city = addresses.find(address => address.types.includes('locality'));
  const state = addresses.find(address => address.types.includes('administrative_area_level_1'));
  const zip = addresses.find(address => address.types.includes('postal_code'));
  const country = addresses.find(address => address.types.includes('country'));
  const latitude = addressObject.geometry.location.lat();
  const longitude = addressObject.geometry.location.lng();
  return {
    addressLocality,
    address1,
    city,
    state,
    zip,
    country,
    latitude,
    longitude
  };
};

export const constructQueryString = queryObj => {
  let queryString = '';
  Object.keys(queryObj).forEach((queryKey, index) => {
    const queryConnector = index === 0 ? '?' : '&';
    queryString = queryString + `${queryConnector}${queryKey}=${queryObj[queryKey]}`;
  });
  return queryString;
};

// add params to the url
// remove duplicate params from the url
// e.g. url : /manager/account?platform=itk
// e.g. queryParamsString : ?page=services&platform=itk
export const constructUrlWithParams = (url, queryParamsString) => {
  if (!url) {
    return url;
  }
  const urls = url.split('?');
  if (!urls[1]) {
    return urls[0] + queryParamsString;
  }
  const urlQueryObj = queryString.parse(urls[1]);
  const queryParamsObj = queryString.parse(queryParamsString);
  for (const key in urlQueryObj) {
    if (!queryParamsObj[key]) {
      queryParamsObj[key] = urlQueryObj[key];
    }
  }
  return urls[0] + constructQueryString(queryParamsObj);
};

export const analyticCode = {
  production: 'UA-2434165-3',
  qa2: 'UA-2434165-9',
  development: 'UA-155727801-1'
};

export const measurementId = {
  production: 'G-HQDBGWJJGL',
  qa2: 'G-P6C6SGMX90',
  development: 'G-P6C6SGMX90'
};

export const isEnlm = () => {
  if(window.build_environment){
    return true
  }
  const hostname = window.location.hostname;
  const isProductionEnlm = hostname.search('enlighten.enphaseenergy') >= 0 || hostname.search('eecs.enphaseenergy.com') >= 0;
  const isPreprodEnlm = hostname.search('enlighten-preprod.enphaseenergy') >= 0;
  const isReleaseEnlm = hostname.search('enlighten-rel') >= 0;
  const isIntegrationEnlm = hostname.search('enlighten-intg') >= 0;
  const isQa2Enlm = hostname.search('qa2.enphaseenergy') >= 0;
  const isQa4Enlm = hostname.search('enlighten-dev') >= 0;
  const isDevelopment = window.location.port === '7000';
  return isProductionEnlm || isPreprodEnlm || isReleaseEnlm || isIntegrationEnlm || isQa2Enlm || isQa4Enlm || isDevelopment;
};

export const getEnlightenOrigin = () => {
  const hostname = window.location.hostname;
  let origin;
  if (isEnlm()) {
    return window.location.origin;
  }
  if (hostname.search('drs.enphaseenergy') >= 0) {
    origin = 'https://enlighten.enphaseenergy.com';
  } else if (hostname.search('drs-preprod.enphaseenergy') >= 0) {
    origin = 'https://enlighten-preprod.enphaseenergy.com';
  } else if (
    hostname.search('drs-ui-stg.qa-enphaseenergy') >= 0 ||
    hostname.search('drs-stg.enphaseenergy') >= 0
  ) {
    if (getValue('referrer') && getValue('referrer').includes('https://enlighten-rel.enphaseenergy.com')) {
      origin = 'https://enlighten-rel.enphaseenergy.com';
    } else {
      origin = 'https://qa2.enphaseenergy.com';
    }
  } else if (
    hostname.search('drs-ui-intg.qa-enphaseenergy') >= 0
  ) {
    origin = 'https://enlighten-intg.qa-enphaseenergy.com';
  }
  else if (hostname.search('drs-ui-dev.qa-enphaseenergy') >= 0) {
    origin = 'https://enlighten-dev.qa-enphaseenergy.com';
  } else if (window.location.port === '4200') {
    origin = 'http://localhost:7000';
  } else {
    origin = 'http://localhost:7000';
  }
  return origin;
};


export const reDirectTo = (path) => {
  window.location.replace(`${getEnlightenOrigin()}${path}`)
};
